import { getUserInfo } from 'ui-addon-upgrades/_core/common/api/getUserInfo';
export const getIsHubSpotOnCreditsPilot = () => {
  return getUserInfo().then(({
    user
  }) => {
    return user.scopes.includes('hubspot-on-credits');
  });
};